module.exports = __webpack_public_path__ + "media/assets/images/blog/glossario_datafication-c987030db9313b9fbc51cfe492f6a394.png";